import { useQuery } from '@tanstack/react-query';
import type { VisibilityReportResponse } from '@brand24-original/llm-types';
import { getVisibilityReport } from '../../services/visibility-report/VisibilityReportService';
import { GET_VISIBILITY_REPORT } from '../../query/visibility-report/keys';

export const useGetVisibilityReport = (reportId: number | null) => {
  return useQuery<VisibilityReportResponse>({
    queryKey: [GET_VISIBILITY_REPORT, reportId],
    queryFn: () => getVisibilityReport(reportId!),
    enabled: reportId != null,
    // Raport jest snapshotem — raz pobrany nie zmieni się już nigdy.
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
